module.exports = __webpack_public_path__ + "static/media/day01.6cb43d2b.jpeg";